export const layers = [
  {
    metadata: {
      'lja:visibility': 'cameras',
      'lja:legend': 'camera',
      'lja:identify': {
        'layer-name': 'Camera',
        'title-field': 'name',
        attributes: [
          {
            field: 'photoDateDisplay',
            kind: 'text',
            label: 'Time of Photo',
          },
          {
            field: 'photo',
            kind: 'image',
            label: 'Photo',
          },
        ],
      },
    },
    type: 'symbol',
    layout: {
      'icon-image': 'circle-white-2', // Included with all Mapbox base styles
      'icon-size': 1.2,
      'icon-padding': 0,
      // NOTE. Allow icon overlap but no text overlap to show icons until they start to overlap text
      'icon-allow-overlap': true,
      'text-font': ['Material Icons Regular'],
      // Material icons character codes https://github.com/google/material-design-icons/blob/master/font/MaterialIcons-Regular.codepoints
      'text-field': String.fromCharCode(0xe412),
      'text-size': 16,
      'text-offset': [0, 0.22],
      'text-padding': 0,
    },
    paint: {
      'text-color': [
        'case',
        ['boolean', ['feature-state', 'lja:highlight'], false],
        'rgba(0, 203, 204, 1)',
        'rgba(0, 0, 0, 1)',
      ],
    },
  },
];
